module.exports = __webpack_public_path__ + "static/media/picto-facebook.031a4e92.svg";